import { Illustration, Text, Title } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { isIosPlatform } from "@src/appV2/lib";

import { TextButton } from "../../components/TextButton";
import { PRIVACY_POLICY_URL } from "../../constants/urls";
import { LocationPermissionsUsesList } from "./LocationPermissionsUsesList";

interface LocationPermissionsContentProps {
  recentlyDisabled?: boolean;
}

export function LocationPermissionsContent(props: LocationPermissionsContentProps) {
  const { recentlyDisabled = false } = props;

  return (
    <Stack direction="column" alignItems="center" px={2} pb={10} spacing={8}>
      <Illustration type="location" />
      <Title variant="h3" component="h3">
        Enable location permissions
      </Title>
      <Text
        color={(theme) => theme.palette.text.secondary}
        sx={{ textWrap: "balance" }}
        variant="body1"
      >
        {recentlyDisabled && (
          <p>Your location permissions were recently disabled for the Clipboard app.</p>
        )}
        <p>
          You must enable the{" "}
          <b>
            &quot;{isIosPlatform() ? "Always" : "Allow all the time"} and Precise Location&quot;{" "}
          </b>
          permissions to book shifts and access the Clipboard marketplace. We collect and use this
          location information for:
        </p>
      </Text>
      <LocationPermissionsUsesList />
      <TextButton size="small" href={PRIVACY_POLICY_URL}>
        Read our privacy policy
      </TextButton>
    </Stack>
  );
}
